const { withPrefix } = require("gatsby");
const root = withPrefix("/");

// using link resolver to override prismic preview paths for custom preview
const linkResolver = doc => {
	if (!doc) return null;

	if (doc.type === "reapredist-home-page") {
		return `${root}preview/index`;
	}

	if (doc.type === "reapredist-district-plans-page") {
		return `${root}preview/district-plans`;
	}

	if (doc.type === "reapredist-demographics-page") {
		return `${root}preview/demographic-data`;
	}

	if (doc.type === "reapredist-history-page") {
		return `${root}preview/history`;
	}

	if (doc.type === "reapredist-get-involved-page") {
		return `${root}preview/getting-involved`;
	}

	return `${root}doc/${doc.id}`;
};

module.exports = linkResolver;
